import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './auth.reducer';
import { User, Organisation } from '../administration/user/user.models';
import { CONFIG } from '../../../config';

export const selectAuthState = createFeatureSelector<State>('auth');

export const selectAuthLoggedIn = createSelector(selectAuthState, (state: State) => state.loggedIn);

export const selectAuthUser = createSelector(selectAuthState, (state: State) => state.user);

export const selectAuthToken = createSelector(selectAuthState, (state: State) => state.token);
export const selectAuthSessionId = createSelector(selectAuthState, (state: State) => state.sessionId);

export const selectAuthLifetime = createSelector(selectAuthState, state => state.lifetime);

export const selectAuthTokenExpiresAt = createSelector(selectAuthState, state => state.expiresAt);

export const selectAuthTokenExpiresIn = createSelector(selectAuthState, state => state.expiresIn);

export const selectAuthUserCountry = createSelector(selectAuthUser, (user?: User) => !!user ? user.country : undefined);

export const selectAuthUserProfileImageId = createSelector(selectAuthUser, (user?: User) =>
  !!user && !!user.profileImageId && !(user.profileImageId.trim() === '') ? user.profileImageId : '');

export const selectAuthUserProfileImageUrl =
  createSelector(selectAuthUserProfileImageId, (userProfileImageID?: string) =>
    userProfileImageID && userProfileImageID.trim() !== ''
      ? `${CONFIG.API_URL}/users/getProfileImage/${userProfileImageID}`
      : undefined);

export const selectAuthUserOrg = createSelector(selectAuthUser, (user?: User) => !!user ? user.org : undefined);

export const selectAuthUserOrgCountry = createSelector(selectAuthUserOrg, (user?: Organisation) => !!user ? user.country : undefined);

export const selectAuthUserType = createSelector(selectAuthUser, (user?: User) => !!user ? user.type : undefined);

export const selectAuthUserRole = createSelector(selectAuthUser, (user?: User) => !!user ? user.role : undefined);

export const selectAuthUserFinancialYearStartMonth = createSelector(selectAuthUser, (user?: User) => !!user
  ? user.settings.preferences.financialYearStartMonth : undefined);

export const selectAuthUserPreferences =
  createSelector(selectAuthUser, (user?: User) => !!user && !!user.settings ? user.settings.preferences : undefined);

export const selectAuthUserReports =
  createSelector(selectAuthUser, (user?: User) => !!user && !!user.settings ? user.settings.reports : undefined);

/* eslint-disable */
export const selectAuthUserNotifications = createSelector(
  selectAuthUser,
  (user: User) => {
    /**
  * Mock data, replace with undefined and fix condition when back-end is ready
  */
    return !!user && !!user.settings && !!user.settings.notifications ? user.settings.notifications : {
      transactions: {
        options: [
          'applications',
          'redemptions',
          'rebate',
          'distribution',
          'transfer',
          'switch',
          'reversal'
        ],
        email: true,
        portal: true
      },
      documents: {
        options: [],
        email: true,
        portal: true
      },
      statements: {
        options: [],
        email: true,
        portal: true
      }
    };
  }
);
export const selectUserNotifications = createSelector(selectAuthState, (state: State) => state.notifications);
export const selectForgotPasswordMailSentStatus = createSelector(selectAuthState, (state: State) => state.forgotPasswordMailSentStatus);
export const forgotPasswordMailSentResponse = createSelector(selectAuthState, (state: State) => state.forgotPasswordMailSentResponse);

